import { useContext } from 'react';
import AppContext from '../../../App/AppContext';

let Home = (props) => {
    const { portalSettings } = useContext(AppContext);
    const bn = !!portalSettings.portalSettingBanner
        ? portalSettings.portalSettingBanner
        : `${process.env.PUBLIC_URL}/${portalSettings.portalSettingBanner}`;

    return (
        <div style={{ height: 'calc(100vh)', overflow: 'hidden' }}>
            <div style={{ height: '100%' }}>
                <img
                    alt="bn"
                    src={bn}
                    height="100%"
                    width="100%"
                    style={{
                        objectFit: 'contain',
                        maxWidth: '500px'
                    }}
                />
            </div>
        </div>
    );
};
export default Home;
